import { Box, Card, CardContent, Divider, Stack, Typography } from '@mui/material';

// Overline label for sub-sections stacked inside a single Section
// (e.g. "Tags" / "Notes", "Attribute Tags" / "Legislative Bills").
export const SubLabel = ({ children }) => (
  <Typography variant="overline" color="text.secondary" sx={{ display: 'block' }}>
    {children}
  </Typography>
);

export const Section = ({ title, children, action, sx }) => {
  const isFlex = sx?.display === 'flex';
  return (
    <Card sx={{ mb: 1, ...(isFlex && { display: 'flex', flexDirection: 'column' }), ...sx }}>
      <CardContent
        sx={{ ...(isFlex && { display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }) }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
          <Typography fontWeight={600}>{title}</Typography>
          {action && action}
        </Stack>
        <Divider sx={{ mb: 1, backgroundColor: '#969696' }} />
        {isFlex ? <Box sx={{ flex: 1, minHeight: 0 }}>{children}</Box> : children}
      </CardContent>
    </Card>
  );
};
